import React, { useEffect, useRef } from "react";
import {
  createChart,
  CrosshairMode,
  CandlestickSeries,
  HistogramSeries
} from "lightweight-charts";

export default function CandleStick({ symbol, data }) {
  const chartContainerRef = useRef();
  const chartRef = useRef();
  const candleSeriesRef = useRef();
  const volumeSeriesRef = useRef();

  useEffect(() => {
    if (!chartContainerRef.current) return;

    const container = chartContainerRef.current;
    const chart = createChart(container, {
      width: container.clientWidth,
      height: container.clientHeight || 450,
      layout: {
        background: { type: "solid", color: "transparent" }, // ✅ KEY FIX
        textColor: "#333",
        attributionLogo: false,
      },
      grid: {
        vertLines: { color: "#f0f0f0" },
        horzLines: { color: "#f0f0f0" }
      },
      crosshair: { mode: CrosshairMode.Normal },
      timeScale: {
        borderColor: "#ccc",
        timeVisible: true
      }
    });

    chartRef.current = chart;

    candleSeriesRef.current = chart.addSeries(CandlestickSeries, {
      upColor: "#26a69a",
      downColor: "#ef5350",
      borderVisible: false,
      wickUpColor: "#26a69a",
      wickDownColor: "#ef5350"
    });

    volumeSeriesRef.current = chart.addSeries(HistogramSeries, {
      priceFormat: { type: "volume" },
      priceScaleId: ""
    });

    chart.priceScale("").applyOptions({
      scaleMargins: { top: 0.8, bottom: 0 }
    });

    const resizeObserver = new ResizeObserver((entries) => {
      const { width, height } = entries[0].contentRect;
      chart.applyOptions({ width, height: height || 450 });
    });

    resizeObserver.observe(chartContainerRef.current);

    return () => {
      resizeObserver.disconnect();
      chart.remove();
    };
  }, []);

  useEffect(() => {
    if (!data || !data.length) return;

    candleSeriesRef.current.setData(data);

    volumeSeriesRef.current.setData(
      data.map(d => ({
        time: d.time,
        value: d.volume,
        color:
          d.close >= d.open
            ? "rgba(38,166,154,0.3)"
            : "rgba(239,83,80,0.3)"
      }))
    );
  }, [data]);

  return (
    <div className="chart-panel">
      <div className="chart-panel__watermark">{symbol}</div>
      <div ref={chartContainerRef} className="chart-panel__canvas" />
    </div>
  );
}